import React from "react";

export default function CurrencySelect({ elem, data, setData }) {
  return (
    <div className="mb-2">
      <label for="nombre">{elem.label}</label>
      <select
        className="selector form-select form-select-sm especialGroup shadow-sm formHover selectHeight"
        name={elem.id}
        id={elem.id}
        onChange={(e) =>
          setData({
            ...data,
            currency: e.target.value,
          })
        }
      >
        {elem.options.map((elem, index) => {
          return (
            <option key={index} values={elem.values}>
              {elem.option}
            </option>
          );
        })}
      </select>
    </div>
  );
}
